export enum FloorActionTypes{
    API_RESPONSE_SUCCESS = '@@floor/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@floor/API_RESPONSE_ERROR',
    ADD_FLOOR = '@@floor/ADD_FLOOR',
    UPDATE_FLOOR = '@@floor/UPDATE_FLOOR',
    DELETE_FLOOR = '@@floor/DELETE_FLOOR',
    GET_AllFLOORS = '@@floor/GET_AllFLOOR',
}
